import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";

const ReportsStatusChangesList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsStatusChanges/ReportsStatusChangesList/ReportsStatusChangesList"
    )
);
export const ReportsStatusChanges = () => {
  return (
    <Layout>
      <ReportsStatusChangesList />
    </Layout>
  );
};
